module.exports = __webpack_public_path__ + "static/media/WINGS-USDC-BUSD.ed8841a0.svg";